import { resolveSanctionedLoanAmount } from '../services/mapUnitDetails';

/**
 * Sanctioned Iskan loan in AED for UI.
 * Prefer profile-details `loan_Amount`, then store / other sources.
 * Returns `0` when the API does not provide a positive amount (no dummy fallback).
 */
export function resolveIskanLoanAmountAed(...amounts: unknown[]): number {
  return resolveSanctionedLoanAmount(...amounts) ?? 0;
}

/**
 * Profile-details loan only (live query + store `loan_Amount`).
 * Missing or zero in profile → `0`; never catalogue / adhaLoanDetails fallbacks.
 * Use for reservation confirm shortfall and unit price breakdown.
 */
export function resolveProfileIskanLoanAmountAed(
  profileLoanFromQuery?: unknown,
  profileLoanFromStore?: unknown,
): number {
  return resolveIskanLoanAmountAed(profileLoanFromQuery, profileLoanFromStore);
}

/**
 * Clamp AED loan into the listing price slider domain (1M–5M).
 * Used by native ADHA listing; web listing always starts at 5M+ and ignores loan.
 */
export function loanAmountAedToSliderMillions(loanAed: number): number {
  const millions = loanAed / 1_000_000;
  if (!Number.isFinite(millions) || millions <= 0) {
    return 5;
  }
  if (millions <= 1) {
    return 1;
  }
  if (millions >= 5) {
    return 5;
  }
  return millions;
}
